module.exports = __webpack_public_path__ + "static/navtosh-kumar-b498ac0aa4c9db868311b990937681bd.jpg";